import React from 'react'
import { calloutStyle as styles } from './callout.tailwind'

const Callout = () => {
  return (
    <section className={styles.section_wrapper}>
      

      {/* Heading */}
      <h2 className={styles.heading}>
        Every dollar of your purchase helps{" "}<span className={styles.highlight}>support athletic programs</span>{" "}and future fan experiences.
      </h2>
    </section>
  )
}

export default Callout
